import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import './page-layout.scss';

type Props = ComponentPropsWithoutRef<typeof Layout>;
export const PageLayout = ({ children, className, ...props }: Props) => {
    return (
        <Layout {...props} className={cn('page-layout', className)}>
            {children}
        </Layout>
    );
};
